import React from "react";

// Replaces [key] markers in a translated string with values or React nodes; user input is never rendered as HTML
const fillTemplate = (template, values = {}) =>
  String(template)
    .split(/(\[\w+\])/)
    .map((part, index) => {
      const key = part.match(/^\[(\w+)\]$/)?.[1];
      return key && key in values ? (
        <React.Fragment key={index}>{values[key]}</React.Fragment>
      ) : (
        part
      );
    });

export default fillTemplate;
